export default "__VITE_ASSET__DLLX$Z6l__"